import { Env } from '@/env';
import { router } from '@/main';
import type { UserRole } from '@shared/modelTypes/user-types';
import { authClient } from 'ht-sdk/auth/client';
import { UserCheck, UserLock } from 'lucide-react';
import { toast } from 'sonner';
import { setUser as sentrySetUser } from '@sentry/browser';

declare module 'ht-sdk/auth' {
	interface SessionClient {
		id: string;
		email: string;
		name: string;
		avatarUrl?: string;
		role: UserRole;
	}
}

console.log('Env.VITE_AUTH_SERVER_URL', Env.VITE_AUTH_SERVER_URL);
console.log('Env.VITE_BASE_URL', Env.VITE_BASE_URL);

export const auth = authClient({
	serverUrl: Env.VITE_AUTH_SERVER_URL,
	baseUrl: Env.VITE_BASE_URL,
	appType: 'web',
	providers: [],
	afterLogin: (client) => {
		sentrySetUser({
			id: client.id,
			username: client.name ?? 'unknown',
		});
		console.log('signed in', client);
		toast('Signed in', { icon: <UserCheck /> });
		// go to onboarding to see if there are any new steps to complete
		// if there are no new steps onboarding will automatically complete and redirect to dashboard
		router.navigate({ to: '/onboarding' });
	},
	afterLogout: () => {
		console.log('signed out');
		toast('Signed out', { icon: <UserLock /> });
		router.navigate({ to: '/login' });
	},
});
